import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class RoutinesAPI extends APIBase{

  constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
    super(authHttp, router, session);
    
    // Entidade principal
    this.__entity = 'routines';
  }

  /**
   * menu
   *
   * Busca o menu relacionado ao usuário
   *
   * @access public
   * @author Murilo Spinoza de Arruda
   * @since  01/2018
   * @param  string
   * @param  string
   * @return object Promise
   */
  public menu() {
    return this._call(this.__entity+'/routines', {}, 'get');
  }
}


// WEBPACK FOOTER //
// ./src/api/routines.api.ts